var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.103,
    height: 31.928,
    viewBox: "0 0 39.103 31.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3054",
    "data-name": "Group 3054",
    transform: "translate(-23707.337 -9071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4392",
    "data-name": "Path 4392",
    d: "M114.978,87.277l-5.152-18.3a.686.686,0,0,0-.47-.473l-4.32-1.24a12.792,12.792,0,0,0,1.206-4.291,6.752,6.752,0,1,0-13.5,0,15.06,15.06,0,0,0,1.583,5.154l-5.539-1.594-.013,0a.685.685,0,0,0-.366,0L81.547,68.5a.686.686,0,0,0-.47.473l-5.152,18.3a.685.685,0,0,0,.659.87.676.676,0,0,0,.189-.027l9.244-2.658,9.244,2.655a1.238,1.238,0,0,0,.189.027.679.679,0,0,0,.189-.027l9.244-2.658,9.244,2.658a.685.685,0,0,0,.848-.841Zm-15.49-29.69a5.388,5.388,0,0,1,5.382,5.382c0,1.232-.953,3.754-2.684,7.1-1.048,2.025-2.1,3.812-2.7,4.744-.6-.932-1.65-2.718-2.7-4.744-1.729-3.346-2.683-5.868-2.683-7.1a5.389,5.389,0,0,1,5.382-5.383ZM87.052,82.415l2.105-14.354,5.61,1.615V86.553l-7.985-2.3Zm-9.476,4.049,4.715-16.751,5.471-1.573L85.4,84.213Zm18.56.088V71.761c.743,1.379,1.377,2.451,1.715,3.008.287.474.543.877.739,1.168.284.42.489.723.9.723s.616-.3.9-.723c.2-.291.452-.694.739-1.168.269-.444.727-1.215,1.277-2.207l1.716,11.7Zm9.365-2.339L103.492,70.53c.328-.639.664-1.318.983-2.006l4.138,1.19,4.715,16.751ZM99.489,66.6a3.635,3.635,0,1,0-2.566-1.065A3.631,3.631,0,0,0,99.489,66.6Zm0-5.893h0a2.265,2.265,0,1,1-1.6.663,2.263,2.263,0,0,1,1.6-.663Z",
    transform: "translate(23631.438 9014.78)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/location_map.d7dda9876348590aa617b2c0b7e923e9.svg";
export { ForwardRef as ReactComponent };